import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import {Project} from '../model/project';
import {ProjectService} from '../project/project.service';
import {CurrentContext} from '../model/currentContext';
import {Questionnaire} from '../model/questionnaire';
import {Terminal} from '../model/terminal';
import {SharedRefreshService} from '../service/sharedRefreshService';
import {ContextMenuComponent} from '../context-menu/context-menu.component';
import {PresentByLargeIconsComponent} from '../FileChooserPresentation/present-by-large-icons.component';
import {Device} from '../model/device';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@Component({
  selector:'file-chooser',
  template: `
    <div [style.display]="hide ? 'none' : 'inline'" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
              <img class="explorerWindow" src="../../assets/images/explorer.png">
              <h4 class="modal-title">File Chooser</h4>
              <h4 class="closeBtnH4"><button (click)="closeFilechooser();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                  <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
              </button></h4>
          </div>
            <div class="modalBodyContainer">
                <div class="modal-body col-md-12" style="background-color:#ECE8E5;">
            <div class="toolbar">
              <div class="col-md-2" style="float: left">
                <button type="button" class="back btn btn-secondary btn-md"  data-toggle="tooltip" data-placement="bottom" (click)="setNavigationIndex(-1)" title="Back"><span><i class="fas fa-chevron-left"></i></span></button>
                <button type="button" class="forward btn btn-secondary btn-md"  data-toggle="tooltip" data-placement="bottom" (click)="setNavigationIndex(+1)" title="Forward"><span><i class="fas fa-chevron-right"></i></span></button>
              </div>
              <div class="col-md-3" style="float: left">
                <button type="button" class="window btn btn-secondary btn-md"  (click)="toggleViewMode('large')" data-toggle="tooltip" data-placement="bottom" title="Large Icon View"><span><i class="fas fa-th-large"></i></span></button>
                <button type="button" class="list btn btn-secondary btn-md"  (click)="toggleViewMode('list')" data-toggle="tooltip" data-placement="bottom" title="List view"><span><i class="fas fa-list"></i></span></button>
                <button type="button" class="category btn btn-secondary btn-md"  data-toggle="tooltip" data-placement="bottom" title="Back"><span><i class="fas fa-columns"></i></span></button>
              </div>
              <div class="col-md-3" style="float: left">
                <div class="btn-group">
                  <button class="btn btn-outline-secondary btn-md" type="button">
                    Small split button
                  </button>
                  <button type="button" class="btn btn-md btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="sr-only">Toggle Dropdown</span>
                  </button>
                  <div class="dropdown-menu">
                    <ul>
                      <li><span><i style="color:#81d8fd;font-size:16px;" class="fas fa-folder"></i></span><span class="dropmenu" style="margin-left: 18px;font-family:Helvetica;font-weight: bold;">Projects</span></li>
                      <li><span><i style="color:#ffd180;font-size:16px;" class="far fa-file-archive"></i></span><span class="dropmenu" style="margin-left: 22px;font-family:Helvetica;font-weight: bold;">Achieve</span></li>
                      <li><span><i style="color:#81d8fd;font-size:16px;" class="fas fa-cloud-upload-alt"></i></span><span class="dropmenu" style="margin-left: 14px;font-family:Helvetica;font-weight: bold;">Cloud</span></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-1" style="float: left">
                <button type="button" class="btn btn-secondary btn-md"  data-toggle="tooltip" data-placement="bottom" title="Back"><span><i class="fas fa-upload"></i></span></button>
              </div>
              <div class="col-md-1" style="float: left">
                <button type="button" class="btn btn-secondary btn-md"  data-toggle="tooltip" data-placement="bottom" title="Back"><span><i class="fas fa-tag"></i></span></button>
              </div>
              <div class="col-md-2" style="float: left">
                <div class="input-group mb-3">
                  <input type="text" class="form-control searchBar" placeholder="Search" aria-label="Recipient's username" aria-describedby="button-addon2" [(ngModel)]="searchBar">
                  <div class="input-group-append">
                    <button type="button" class="btn btn-secondary btn-md"  data-toggle="tooltip" data-placement="bottom" title="search"><span><i class="fas fa-search"></i></span></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="w3-card-4" style="background-color:#ECE8E5;">
              <div class="col-md-2" style="float: left; background-color:#ECE8E5;border-style:groove none groove groove;border-width:1px;height: 550px; ">
                <div style="font-family: Helvetica;color:#909090;font-weight: bold;font-size:13px;">Projects</div>
                <div>
                  <table class="menu">
                    <tr><td><span><i style="color:#81d8fd;font-size:20px;" class="fas fa-folder"></i></span></td><td style="font-family: Helvetica;font-size: small;font-weight: bold;">Recent</td></tr>
                    <tr><td><span><i style="color:#ffd180;font-size:20px;" class="far fa-file-archive"></i></span></td><td style="font-family: Helvetica;font-size: small;font-weight: bold;">Archive</td></tr>
                    <tr><td><span><i style="color:#81d8fd;font-size:20px;" class="fas fa-cloud-upload-alt"></i></span></td><td style="font-family: Helvetica;font-size: small;font-weight: bold;">Cloud Drive</td></tr>
                  </table>
                </div>
              </div>
              <div class="col-md-10" style="float: left; overflow-y: auto; height:550px;max-height:550px;border-style: groove;border-width:1px;">
               <!-- <present-by-list *ngIf="this.viewMode==='list'" [projectList]="searchBar.length ==0?_projects:this.foundItems|name:searchBar:'name'" [targetName]="target" [context]="context"></present-by-list>-->
                  <present-by-large-icons  [viewMode]="viewMode" [projectList]="searchBar.length ==0?_projects:this.foundItems|name:searchBar:'name'" [targetName]="target" [context]="context" [devices]="_devices"></present-by-large-icons>
              </div>
            </div>
          </div>
                <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles:[`
    .menu td{padding-left: 20px;}
    .back{margin-right:10px;}

    .modal-title{margin-left:10px;}
    .explorerWindow{height:32px;}
    .window{margin-right: 10px;}
    .list{margin-right: 10px;}
    li {list-style: none;}
    table {width: 100%;}
  tr:nth-child(even){background-color: #ffffff}
  tr:nth-last-child(odd){background-color: #f5f5f5}

    ul li:hover {
      background: -webkit-linear-gradient(top, #648bf5, #2866f2);
      background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
      border-top: 1px solid #5a82eb;
      border-bottom: 1px solid #1758e7;
    }

    ul li:hover::after .dropmenu{
      color: #ffffff;
    }

    .modal-header{
        background-color:dodgerblue;
        color:antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    .modal-content{
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
    }
    .closeX{color:azure;size:25px;}
    .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
    .btn-danger:hover{background-color: #FF2400;}


    .toolbar{margin-top:15px;}

    .modal-title{margin-top: -5px;}
    .closeBtnH4{margin-top:-5px;margin-right: -8px;}
    .appWindow {
        height: 35px;
    }
    .clientRow{background-color: #D0DFFE;}

    .led{width:22px;}

    .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
    th{color:#ffffff;text-align: center;}

    .modalBodyContainer{
      background-color:  #ECE8E5;
    }

    .modal-footer{background-color: #ECE8E5;border-top:groove;}
    .modal-body {
        width: 100%;
        padding: 0;
        overflow-y: auto;
        height: 600px;
    }
    .modal-body thead {
        position: sticky;
        top:0;
    }
    ::-webkit-scrollbar {
        width: 14px;
        height: 5px;
        background-color: #F5F3F0;
    }
    ::-webkit-scrollbar-thumb {
        height: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-border-radius: 7px;
        background-color:#BACEFF;
        -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
    ::-webkit-scrollbar-button {
        width: 14px;
        height: 14px;
        display: none;
    }
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    .modal-dialog {
        max-width: 1500px;
        margin: 50px auto auto;
    }

    .modal-header {
        height:56px;
    //background-color: #0064FE;
        background-image: url("../../assets/images/headerBack.jpg");
        color: antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-content {
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      padding-left: 3px;
      padding-right: 3px;
      background-color: #0064FE;
      padding-bottom: 3px;
    }

    .closeX {
        color: white;
        size: 25px;
    }

    .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
    }

    /* .btn-outline-danger:hover {
         width: 32px;
         background-image: url("../../../assets/images/closeBtnHovered.png");
     }*/

    .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

    .closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}
  `]
})
export class FileChooserComponent implements OnInit, OnDestroy {

  private _projects:Project[];
  private _devices:Device[];
  private hide = true;
  private searchBar='';
  private errorMessage:string;
  private target:string; // button which has triggred the file-chooser
  @Input() context:CurrentContext;
  private foundItems:Array<Terminal |Project|Questionnaire>;


  private viewMode = 'large';

  @ViewChild(PresentByLargeIconsComponent) private presentLargeIcons:PresentByLargeIconsComponent;
  // @ViewChildren('Children') Children: QueryList<ElementRef>;

  constructor(private _projectService:ProjectService,_refreshService:SharedRefreshService) {

      _refreshService.refreshEmitted.subscribe((val) => {
          if(val) {
              this.getProject();
          }
      });
  }
  ngOnDestroy(): void {
  }

  ngOnInit(): void {

  }

  private getProject() {
      this._projectService.getProjects()
          .subscribe(
              projects => {
                  this._projects = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(projects,Project);// new Array<Project>();
                  console.log(this._projects);

                  for(let i = 0; i< projects.length;i++) {
                      // this._projects.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(projects[i],Project));
                      console.log(this._projects[0]);
                  }

                  this.foundItems = new Array<Terminal |Project|Questionnaire>();

                  let quest:Questionnaire[] = [];
                  let term:Terminal[] = [];

                  for (let i = 0; i < this._projects.length; i++) {
                      quest = quest.concat(this._projects[i].questionnaires);
                      console.log('');
                  }
                  for(const q of quest) {
                      term = term.concat(q.terminals);
                  }

                  this.foundItems = this.foundItems.concat(this._projects);
                  this.foundItems = this.foundItems.concat(quest);
                  this.foundItems = this.foundItems.concat(term);

              },
              error => this.errorMessage = <any>error);
  }

  private getRegisteredDevices() {
      this._projectService.listRegisteredDevices().subscribe( (data)=> {
          this._devices = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(data,Device);
      },err=> {});
  }

  public closeFilechooser() {
      this.hide = !this.hide;
  }

  public toggleFileChooser(content:string) {
      if(this.hide === false) {
          return;
      }
      switch (content) {
          case 'devices':this.getRegisteredDevices();this.presentLargeIcons.prepareDeviceView();break;
          case 'projects':this.getProject();break;
      }
    this.hide = !this.hide;
  }

  public setTarget(src:string) {
    this.target = src;
  }

  public toggleViewMode(mode: string) {
      this.viewMode = mode;
  }

    setNavigationIndex(input: number) {
        // this.navigationInput= input;
        this.presentLargeIcons.navigate(input);
    }
}
